'use client';

import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { useSafeSelector } from "@/hooks/useSafeSelector";

export function SnackbarListener() {
  const {
    toasterMessage = "",
    messageToaster = false,
    toasterType = "default",
  } = useSafeSelector((state) => state.notification, {});

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (messageToaster && toasterMessage) {
      enqueueSnackbar(toasterMessage, {
        variant: toasterType, // success | error | warning | info
      });
    }
  }, [messageToaster, toasterMessage, toasterType, enqueueSnackbar]);

  return null;
}
